const url = new URL('https://mercure.kjaniszewski.pl/.well-known/mercure');
url.searchParams.append('topic', `jedzonko/event`);

const eventSource = new EventSource(url);

eventSource.onmessage = (e) => {
    const data = JSON.parse(e.data);

    if ($('#addProduct').hasClass('show')) {
        return;
    }

    switch (data.topic) {
        case 'jedzonko/event':
            location.reload();
            break;
    }
}
